import { gql } from 'apollo-angular';
export var update_closing_feasibility_notes = gql`
  mutation updateClosingFeasibililtyNotes($id: ID!, $notes: String!) {
    updateClosingFeasibilityNotes(id: $id, closing_feasibility_notes: $notes){
      id, closing_feasibility_notes
    }
  }
`;

export var update_rate_lock = gql`
  mutation updateRateLock($id: ID!, $rate_locked_flag: Boolean!) {
    updateRateLock(id: $id, rate_locked_flag: $rate_locked_flag){
      id, rate_locked_flag
    }
  }
`;

export var update_financing_term_loans = gql`
  mutation updateFinancingTermLoans($input: UpsertFinancingTerms) {
    upsertFinancingTermLoans(input: $input){
      id,
      financingTerms{
        id,
        loan {
          id, amount, available_to_investor,
          loanType{
            id, name
          },
          lender{
            id, name
          }
        }
      }
    }
  }
`;

export var delete_loan = gql`
  mutation deleteLoan($id: ID!) {
    deleteLoan(id: $id){
      id,
      loan {
        id, amount, available_to_investor,
        loanType{
          id, name
        },
        lender{
          id, name
        }
      }
    }
  }
`;

export var lender_by_name = gql`
  query lenderByName($name: String!) {
    lenderByName(name: $name){
      id, name
    }
  }
`;
